module.exports = __webpack_public_path__ + "img/tc-10.d25eeac0.png";